"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableOptions = void 0;
var colors_1 = require("../../constants/colors");
var styled_components_1 = __importDefault(require("styled-components"));
var colorHelpers_1 = __importDefault(require("../../utils/colorHelpers"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
exports.ClickableOptions = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: ", ";\n  cursor: pointer;\n  display: ", ";\n  font-size: 14px;\n  left: 0;\n  position: absolute;\n  text-align: left;\n  top: ", ";\n  width: ", ";\n  z-index: 10;\n  height: ", ";\n  overflow: auto;\n"], ["\n  background-color: ", ";\n  border: ", ";\n  cursor: pointer;\n  display: ", ";\n  font-size: 14px;\n  left: 0;\n  position: absolute;\n  text-align: left;\n  top: ", ";\n  width: ", ";\n  z-index: 10;\n  height: ", ";\n  overflow: auto;\n"])), function (_a) {
    var selectOptionsWrapperBackgroundColor = _a.selectOptionsWrapperBackgroundColor, theme = _a.theme;
    return colorHelpers_1.default(selectOptionsWrapperBackgroundColor, theme, colors_1.colors.WHITE);
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return "1px solid " + colorHelpers_1.default(borderColor, theme, colors_1.colors.GREY_400);
}, function (_a) {
    var show = _a.show;
    return show ? 'block' : 'none';
}, function (_a) {
    var topPosition = _a.topPosition;
    return topPosition ? topPosition : '50px';
}, function (_a) {
    var width = _a.width;
    return width ? width : '100%';
}, function (_a) {
    var height = _a.height;
    return height ? height : 'auto';
});
var templateObject_1;
//# sourceMappingURL=ClickableOptions.js.map